import React from 'react';
import moment from 'moment';
import { first } from 'lodash';

const ReviewLikeList = ({ social, users = [] }) => {
  const userArray = users.filter(
    item => item.user_id === social.audit.updated_by,
  );

  const user = userArray.length !== 0 ? first(userArray) : undefined;

  return (
    <tr>
      <td>
        {user ? (
          <React.Fragment>
            <p>{user.display_name} </p>
          </React.Fragment>
        ) : (
          social.audit.updated_by
        )}
      </td>
      <td>{user && user.email}</td>
      <td>{moment(social.audit.updated_at).format('lll')}</td>
    </tr>
  );
};

export default ReviewLikeList;
